<template>
  <!-- desktop only: on phones the player table shows our % and its drop-down has the odds and value -->
  <div class="hidden md:flex items-center justify-end gap-2 mt-2">
    <!-- bet365 is the only bookmaker that prices player bets for us -->
    <span v-if="view !== 'pct'" class="text-xxs text-gray-500 mr-auto whitespace-nowrap">bet365 odds</span>
    <span class="text-xxs text-gray-500" id="prop-view-label">Show</span>
    <div class="prop-view-seg" role="group" aria-labelledby="prop-view-label">
      <button
        v-for="option in options"
        :key="option.value"
        type="button"
        :aria-pressed="String(view === option.value)"
        v-on:click="choose(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>

<script>
import { trackFeature } from "../../analytics";

export default {
  name: "PropViewSwitch",
  data() {
    return {
      options: [
        { value: "pct", label: "Our %" },
        { value: "odds", label: "Odds" },
        { value: "value", label: "Value" },
      ],
    };
  },
  computed: {
    view() {
      return this.$store.state.betslip.propView;
    },
  },
  methods: {
    choose(view) {
      this.$store.commit("betslip/setPropView", view);
      trackFeature("prop_view", "betslip", { view });
    },
  },
};
</script>

<style scoped>
/* the Filter panel's square toggles */
.prop-view-seg {
  display: inline-flex;
  border: 1px solid var(--ng-line-strong, #9ca3af);
  background: var(--ng-surface, #fff);
}
.prop-view-seg button {
  font-size: 0.75rem;
  padding: 2px 10px;
  color: var(--ng-link, #1d4ed8);
  border-left: 1px solid var(--ng-line-strong, #9ca3af);
}
.prop-view-seg button:first-child {
  border-left: 0;
}
.prop-view-seg button[aria-pressed="true"] {
  background: #1d4ed8;
  color: #fff;
}
</style>
